(function() {
    'use strict';

    angular.module('MW.CoreStream', [
        'MW.CoreStream.CsHeader',
        'MW.CoreStream.CsSelectAllHeader',
        'MW.CoreStream.CsSelectDropDown',
        'MW.Influencers.ContactCard',
        'MW.CoreStream.SourceCard'
    ]);

    angular.module('MW.CustomValidation', [
        'MW.CustomValidation.ContactManagerUsernameService',
        'MW.CustomValidation.twitterValidator',
        'MW.CustomValidation.facebookValidator',
        'MW.CustomValidation.linkedinValidator',
        'MW.CustomValidation.validateOnblur',
        'MW.Framework.InfluencerContactService',
        'MW.Framework.RelevantArticlesDialogService',
        'MW.Framework.EntitlementService',
        'MW.Framework.ICMEntitlementService',
        'MW.Framework.ICMEmailService',
        'MW.Framework.CoreUserService',
        'MW.Framework.CoreCompanyService',
        'MW.Framework.ICMUserService',
    ]);

    angular.module('icmWebApp', [
        'ngMaterial',
        'ngMessages',
        'templates',

        'mwAppComponents',
        'navigationController',

        //Controllers
        'MW.ContactManager.ContactLandingController',
        'MW.ContactManager.ContactManagerAddController',
        'MW.ContactManager.ContactManagerFormController',
        'MW.ContactManager.ContactManagerIcmEnquiryController',
        'MW.ContactManager.ContactManagerImportController',
        'MW.ContactManager.ContactManagerInfluencerDatabaseUpsellController',
        'MW.ContactManager.ListViewController',
        'MW.ContactManager.ContactManagerNavigationService',
        'MW.ContactManager.ContactManagerOutreachComposeController',
        'MW.ContactManager.ContactManagerOutreachListController',
        'MW.ContactManager.ContactManagerOutreachViewController',
        'MW.ContactManager.ContactManagerProfileController',
        'MW.ContactManager.ContactManagerSourceProfileController',
        'MW.ContactManager.ContactHistoryTableController',
        'MW.ContactManager.MediaListController',

        'MW.ContactManager.SearchTutorial',
        'MW.ContactManager.MediaListEmptyState',
        'MW.ContactManager.DeleteMediaList',
        'MW.ContactManager.TemplateWarning',
        'MW.ContactManager.ProtectEditedOutreach',
        'MW.CoreStream.ComposeMedialists',
        'MW.ContactManager.SelectionFactory',

        'MW.Influencers.AlertController',
        'MW.Framework.Breadcrumb',
        'MW.Framework.CoreBreadcrumb',
        'MW.Framework.CoreGrid',
        'MW.Framework.CoreGridActionButtons',
        'MW.Framework.CoreGridFilterBox',
        'MW.Framework.CoreGridTable',
        'MW.Framework.CoreStaticPageController',
        'MW.Framework.CoreUserService',
        'MW.Framework.Dialog',
        'MW.Framework.GydaSwitch',
        'MW.Framework.inputCancel',
        'MW.Framework.FeatureToggleService',
        'MW.Framework.PageStateService',
        'MW.Framework.ScrollableDiv',
        'MW.Framework.SearchBar',
        'MW.Framework.SelectAccordion',
        'MW.Framework.SettingsSummary',
        'MW.Framework.SettingsTabBar',
        'MW.Framwork.TranslateAttribute',
        'MW.Framework.TranslateFilter',
        'MW.Framework.TranslationService',
        'MW.Framework.Translate',
        'pascalprecht.translate',
        'MW.Framework.UIFilters',
        'MW.Framework.CsStickyHeader',
        'MW.Framework.NotificationsModule',
        'MW.Influencers.IcmDialogService',

        'AuthTokenHttpInterceptor',

        'MW.Framework.Editor.v5',

        'MW.Influencers.SearchV2',
        'MW.Influencers.SearchSwitcherController',
        'MW.Influencers.ProfileSwitcherController',
        'MW.Influencers.SourceSwitcherController',
        'MW.Influencers.SearchEmptyState',
        'MW.Influencers.IcmLanguageService',
        'MW.Influencers.OutreachBannerService',
        'MW.Influencers.SendgridService',
        'MW.Influencers.IdentityService',

        'MW.Configuration',
        'MW.Influencers.ActionBarComponent',

        'MW.Influencers.CloudwatchService'
    ])
    .constant('MW_STATE_TRACKING_ENABLED', true);
}());
